<template>
    <el-dialog custom-class="xian-yu-dialog-class" :title="title" :visible.sync="dialogVisible" @close="close" width="900px" :close-on-click-modal="false" :before-close="close">
        <div class="dialog-box">
            <el-card shadow="hover" size="small">
                <el-form ref="formQuery" :model="query"  :inline="true" size="small"> 
                    <el-form-item label="客户ID:"> 
                        <el-input class="form-input" clearable v-model="query.trader_id" placeholder="请输入客户ID" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="客户名称:"> 
                        <el-input class="form-input" clearable v-model="query.trader_name" placeholder="请输入客户名称" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="链接名称:"> 
                        <el-input class="form-input" clearable v-model="query.link_name" placeholder="请输入链接名称" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="链接:"> 
                        <el-input class="form-input" clearable v-model="query.xianyu_link" placeholder="请输入链接" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="面值:"> 
                        <el-input class="form-input" clearable v-model="query.denomination_value" placeholder="请输入面值" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="闲鱼接单状态:"> 
                        <el-select class="form-input" clearable v-model="query.xianyu_enabled" placeholder="请选择" size="small"> 
                            <el-option label="开启" :value="1"></el-option>
                            <el-option label="关闭" :value="0"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item> 
                     
                        
                    </el-form-item>
                </el-form>
                <div>
                    <el-button type="primary" @click="getData" size="small">查询</el-button>
                    <el-button @click="reset" size="small">重置</el-button>
                </div>
            </el-card>
            <div class="xian-yu-table-div">
                <el-table class="table-class" border max-height="50vh" :data="xianYuData.tableData" style="width: 100%;" header-row-class-name="header-row-class-name" header-cell-class-name="header-class-name" cell-class-name="cell-class-name">
                    <el-table-column prop="trader_id" label="客户ID"></el-table-column>
                    <el-table-column prop="trader_name" label="客户名称" ></el-table-column>  
                    <el-table-column prop="denomination_value" label="面值" width="100px"></el-table-column>
                    <el-table-column prop="link_name" label="链接名称" ></el-table-column>                                    
                    <el-table-column label="链接" width="240px" align="center">
                        <template slot-scope="scope">
                            <el-link type="primary">{{scope.row.xianyu_link}}</el-link>
                        </template>
                    </el-table-column>                   
                    <el-table-column label="闲鱼接单状态" width="240px" align="center">
                        <template slot-scope="scope">
                            <div class="face-value-list">
                               <el-tag size="small" :type="scope.row.xianyu_enabled == 1 ? 'success' : 'danger'">{{scope.row.xianyu_enabled_text }}</el-tag>                                
                            </div>
                        </template>
                    </el-table-column>
                    
                </el-table>
                <div class="flexX pageBox flexEnd">
                    <el-pagination :disabled="xianYuData.loading" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="query.page" :page-sizes="xianYuData.pageSizesArr"
                        :page-size="query.size" layout="total, sizes, prev, pager, next" :total="xianYuData.total"></el-pagination>
                </div>
                
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button size="mini" @click="close">关 闭</el-button>
        </div>
    </el-dialog>
</template>
<script>

export default {
    name:"xianYuManage",
    props:{
        dialogVisible:{
            type: Boolean,
            default:false,
        },
        title:{
            type: String,
            default: ''
        },
        formData:{
            type: Object,
            default: function () {
                    return {}
                }
        },
        loading:{  
            type: Boolean,
            default: false
        },
        type:{
            type: String,
            default: ''
        }
    },
    data() {
        return {           
            xianYuData:{              
                loading:false,
                pageSizesArr:[10,50,200,500],
                total:0,
                tableData:[],
            },  
            query:{
                product_code:'',
                page:1,
                size: 10,
                trader_id:'',
                trader_name:"",
                link_name:'',
                xianyu_link:'',
                denomination_value:'',
                xianyu_enabled:''
            }
        }
    },
    methods:{
        //查询按钮
        getData(){
            this.query.page = 1
            this.getXianYuData()
        },
        getXianYuData(){
            this.xianYuData.loading = true
            this.$api.getXianyu(this.query).then(res=>{
                this.xianYuData.loading = false
                if(res.status == 1){ 
                    this.xianYuData.tableData = res.data.data
                    this.xianYuData.total = res.data.total
                }else{
                    Message({
                        message: res.msg,
                        type: 'error',
                        duration: 3 * 1000
                    });
                }
            }).catch(e=>{
                this.xianYuData.loading = false
            })
        },
        // 重置按钮
        reset(){
            this.query.trader_id = '';
            this.query.trader_name = "";
            this.query.link_name = '';
            this.query.xianyu_link = '';
            this.query.denomination_value = '';
            this.query.xianyu_enabled = '';     
              
            this.getData()
        },
        // 分页查询数据
        handleSizeChange(val){
            this.query.size = val;
            this.query.page = 1
            this.xianYuData.total = 0
            this.getXianYuData()
        },
        handleCurrentChange(val){
            this.query.page = val
            this.getXianYuData()
        },
        close(){
            this.$emit('close')
        },
    },
    mounted(){
        this.query.product_code = this.formData.product_code
        this.getData()
    },
}
</script>
<style lang="scss">
     .xian-yu-dialog-class{
        .el-dialog__body{
            padding-top: 10px;
            padding-bottom: 10px;
        }
        .el-form--inline .el-form-item{
            margin-right:32px;
        }
     }
</style>
<style lang="scss" scoped>
    .xian-yu-dialog-class{
        .xian-yu-table-div{
            margin-top: 20px;
            .pageBox{
                margin-top: 16px;
            }
        }
        .form-input{
            width: 155px;
        }
    }

</style>
